var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "20",
      "viewBox": "23 23 25 20"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#FFF",
      "stroke-linecap": "square",
      "stroke-width": "2",
      "d": "M23 23.5h25M23 33h25m-25 9.5h25"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }